import {
  BedDouble,
  BookOpen,
  Box,
  Brain,
  Brush,
  CalendarClock,
  CalendarDays,
  CalendarX2,
  ChartNoAxesCombined,
  CircleDollarSign,
  ConciergeBell,
  Dumbbell,
  Earth,
  Gift,
  Handbag,
  Heater,
  Hotel,
  Landmark,
  Lightbulb,
  Luggage,
  LucideIcon,
  MailCheck,
  MessageSquarePlus,
  MonitorSmartphone,
  NotebookPen,
  NotepadText,
  Package,
  PenLine,
  PlaneTakeoff,
  ReceiptText,
  Refrigerator,
  Search,
  Send,
  Sofa,
  Siren,
  Sparkles,
  SprayCan,
  Tag,
  TicketPercent,
  TreePalm,
  TrendingUp,
  Undo2,
  UtensilsCrossed,
  WashingMachine,
} from 'lucide-react';

export interface ToolIcon {
  icon: LucideIcon;
  flipHorizontal?: boolean;
}

export type ToolIconConfig = LucideIcon | ToolIcon;

export function isToolIconObject(config: ToolIconConfig): config is ToolIcon {
  return typeof config === 'object' && 'icon' in config;
}

export const FLIGHT_ICONS: ToolIconConfig[] = [
  CalendarDays,
  PlaneTakeoff,
  Earth,
  { icon: PlaneTakeoff, flipHorizontal: true },
];
export const HOTEL_ICONS: ToolIconConfig[] = [CalendarDays, Hotel, TreePalm, Luggage];
export const HOTEL_FILTER_ICONS: ToolIconConfig[] = [
  BedDouble,
  UtensilsCrossed,
  ConciergeBell,
  Sparkles,
];
export const VACATION_PACKAGE_ICONS: ToolIconConfig[] = [
  CalendarDays,
  PlaneTakeoff,
  Hotel,
  TreePalm,
  Luggage,
  { icon: PlaneTakeoff, flipHorizontal: true },
];
// TODO: replace with dedicated organized-trip icons when design provides them
export const ORGANIZED_TRIP_ICONS: ToolIconConfig[] = VACATION_PACKAGE_ICONS;
export const HOTEL_INFO_ICONS: ToolIconConfig[] = [
  BedDouble,
  UtensilsCrossed,
  Sparkles,
  Dumbbell,
  ConciergeBell,
];
export const DEALS_ICONS: ToolIconConfig[] = [TicketPercent, Tag, Siren];
export const KNOWLEDGE_ICONS: ToolIconConfig[] = [Search, NotepadText, Brain, Lightbulb];
export const PRODUCT_ICONS: ToolIconConfig[] = [
  Refrigerator,
  WashingMachine,
  MonitorSmartphone,
  Heater,
];
export const KETER_PRODUCT_ICONS: ToolIconConfig[] = [Sofa, Package, TreePalm, Box];
/** Finance icons for t19 fund-search trail steps. */
export const FUND_ICONS: ToolIconConfig[] = [
  ChartNoAxesCombined,
  Landmark,
  CircleDollarSign,
  TrendingUp,
];
export const BEAUTY_ICONS: ToolIconConfig[] = [SprayCan, Handbag, Brush, Gift];
/** T4 post-sale reservation steps. */
export const CANCELLATION_QUOTE_ICONS: ToolIconConfig[] = [CalendarClock, ReceiptText];
export const CANCEL_RESERVATION_ICONS: ToolIconConfig[] = [CalendarX2, Hotel, Undo2];
export const SPECIAL_REQUEST_ICONS: ToolIconConfig[] = [
  MessageSquarePlus,
  NotebookPen,
  ConciergeBell,
];
export const RESEND_CONFIRMATION_ICONS: ToolIconConfig[] = [Send, MailCheck];
export const TEXT_STEP_ICONS: ToolIconConfig[] = [PenLine, Sparkles, BookOpen];

/** Domain-neutral icons for activity-trail rows whose tool has no tenant-specific config. */
export const GENERIC_TOOL_ICONS: ToolIconConfig[] = [Search, Sparkles, Brain];
